function normalizeName(value: string): string {
  return value.normalize("NFD").replace(/\p{M}/gu, "").trim().replace(/\s+/g, " ").toLowerCase();
}

export function namesMatch(a: string, b: string): boolean {
  return normalizeName(a) === normalizeName(b);
}

export function needsNameConfirmation(
  lawyerName: string | null | undefined,
  contactName: string,
): boolean {
  if (!lawyerName || !lawyerName.trim()) return false;
  return !namesMatch(lawyerName, contactName);
}
